export const strokeJoinBevelIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M8 3c-6.004 6.004.983-.979-5 5v12h2V9l4-4h11V3zm1 6v4h1v7h2v-7h1v-1h7v-2h-7V9zm6 6v5h2v-3h3v-2z"/></svg>`,
  name: 'stroke-join-bevel',
};
